class VoyagerLightbox {
    constructor(options) {
        this.options = Object.assign(
            {
                selector: ".js-voyager-lightbox",
                itemSelector: '.js-voyager-lightbox__item',
                icons: {
                    close: '<svg class="voyager-lightbox__button-close--svg" width="46px" height="46px" viewBox="0 0 46 46" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="close-(6)-1" fill-rule="nonzero"><rect id="Rectangle" fill="#F1E4D7" x="0" y="0" width="46" height="46" rx="23"></rect><path d="M13.2077,32.7905 C13.2741,32.8569 13.3528,32.9096 13.4396,32.9456 C13.5263,32.9815 13.6192,33 13.7131,33 C13.807,33 13.8999,32.9815 13.9866,32.9456 C14.0734,32.9096 14.1521,32.8569 14.2185,32.7905 L22.9974,24.0124 L31.7799,32.7905 C31.9139,32.9245 32.0957,33 32.2853,33 C32.4748,33 32.6566,32.9245 32.7907,32.7905 C32.9247,32.6565 33,32.4747 33,32.2852 C33,32.0956 32.9247,31.9139 32.7907,31.7799 L24.0082,23.0017 L32.7871,14.22 C32.9211,14.086 32.9964,13.9042 32.9964,13.7146 C32.9964,13.5251 32.9211,13.3433 32.7871,13.2093 C32.6531,13.0753 32.4713,13 32.2817,13 C32.0922,13 31.9104,13.0753 31.7763,13.2093 L22.9974,21.991 L14.2149,13.2129 C14.0783,13.0959 13.9025,13.0347 13.7227,13.0417 C13.5429,13.0486 13.3724,13.1231 13.2452,13.2503 C13.118,13.3775 13.0434,13.5481 13.0365,13.7278 C13.0295,13.9076 13.0907,14.0833 13.2077,14.22 L21.9867,23.0017 L13.2077,31.7834 C13.0747,31.9172 13,32.0983 13,32.287 C13,32.4757 13.0747,32.6567 13.2077,32.7905 Z" id="Path" fill="#C29D5F"></path></g></g></svg>',
                }
            },
            options
        );

        this.setData = [];
        this.getData = [];
        this.isOpen = false;
        this.popupMain;
        this.currentItems;
        this.singleItem;
        this.currentIndex;
        this.selectorDataset;
        this.mainSplide;
        this.story;
    }

    groupElement() {
        var _self = this;
        const { selector } = _self.options;
        var group_element = document.querySelectorAll(selector);
        
        if (group_element.length === 0) {
            _self.options.selector = '.voyager-lightbox'
        }        
        
        document.querySelectorAll(_self.options.selector)?.forEach((element) => {            
            if (element.dataset.lightboxGroup == undefined) {
                console.log('Please Use data-gallery attribute in parent element.');
                return false
            }
            _self.itemElement(element);
        });
    }

    itemElement(element) {
        var _self = this,
            items = [];
        const { itemSelector } = _self.options;
        var item_element = element.querySelectorAll(itemSelector);
        if (item_element.length === 0) {
            _self.options.itemSelector = '.voyager-lightbox__item'
        }        

        element.querySelectorAll(_self.options.itemSelector)?.forEach((element, i) => {
            var caption = element.dataset.lightboxCaption,
                poster = element.dataset.lightboxPoster,
                popup_content = element.dataset.popupContent;

            items.push({ 'link': element.href, 'type': element.dataset.lightboxMediaType, 'caption': caption, 'poster': poster, 'popup_content': popup_content });
            _self.handleItemClick(element, i);
        });
        _self.setData.push({ 'id': element.dataset.lightboxGroup, 'item': items })
    }

    handleItemClick(element, i) {
        var _self = this;
        const { selector } = _self.options;
        element.addEventListener('click', function (e) {
            
            e.preventDefault();
            _self.getData = [];
            _self.popupMain = '';
            _self.selectorDataset = this.closest(selector).dataset;

            document.body.classList.add('js-lightbox-opened');

            var id = _self.selectorDataset.lightboxGroup;

            // Create the parent div with class 'voyager-lightbox' and 'js-voyager-lightbox'
            const parentDiv = document.createElement('div');
            parentDiv.classList.add('voyager-lightbox', 'js-voyager-lightbox__popup');
            // Create the child div with classes 'voyager-lightbox__container'
            const overlayDiv = document.createElement('div');
            overlayDiv.classList.add('voyager-lightbox__content-overlay');
            // Create the child div with classes 'voyager-lightbox__container'
            const childDiv = document.createElement('div');
            childDiv.classList.add('voyager-lightbox__container');
            if(_self.selectorDataset.story !== undefined) {
                childDiv.classList.add('voyager-story__popup-container');
            }
            // Append the child div to the parent div
            parentDiv.appendChild(overlayDiv);
            parentDiv.appendChild(childDiv);

            _self.getData = _self.setData.find((item) => item.id === id);
            document.body.appendChild(parentDiv);
            _self.popupMain = document.querySelector('.js-voyager-lightbox__popup');
            // _self.story = new Story();
            _self.story = typeof Story !== 'undefined' ? new Story() : null;
            childDiv.innerHTML = _self.popupHtml();
            _self.currentIndex = i;
            _self.splideInit();
            _self.handlePopupClose();
            _self.isOpen = true;
        });
    }

    popupHtml() {
        var _self = this;
        if (!_self.isOpen) {
            var outputHTML = `
                <div class="voyager-lightbox__slider-container">
                    <div class="voyager-lightbox__slider voyager-lightbox__splide splide js-lightbox-items">
                        <div class="voyager-lightbox__splide-track splide__track">
                            <div class="voyager-lightbox__splide-list splide__list">
                                ${_self.getItemsHtml().mainSlideHTML}
                            </div>
                        </div>
                        ${_self.arrowsHtml()}
                    </div>
                    ${_self.closeHtml()}
                    ${_self.thumbnailHtml()}
                </div>`;
            return outputHTML;
        }
    }

    getItemsHtml() {
        var _self = this,
            mainSlideHTML = '',
            thumbnailItemHtml = '';
        _self.currentItems = _self.getData.item;
        _self.currentItems.forEach(function (item) {
            _self.singleItem = [];
            _self.singleItem = item;
            mainSlideHTML += _self.mainSlideHTML();
            thumbnailItemHtml += _self.thumbnailItemHtml()
        });

        return {
            'mainSlideHTML': mainSlideHTML,
            'thumbnailItemHtml': thumbnailItemHtml
        };
    }

    mainSlideHTML() {
        var _self = this;   

        var outputHTML = `
            <div class="voyager-lightbox__slide-content voyager-lightbox__splide-slide splide__slide">
                <div class="voyager-lightbox__slide-media js-lightbox-media">
                    ${_self.addMedia().mediaHTML}
                </div>`
        if(_self.addMedia().caption) {
            outputHTML += `<div class="voyager-lightbox__slide-description-wrap">
                <div class="voyager-lightbox__slide-description-inner">
                    <h4 class="voyager-lightbox__slide-title js-lightbox-caption">${_self.addMedia().caption}</h4>
                    <div class="voyager-lightbox__slide-description"></div>
                </div>
            </div>`;
        }
        outputHTML += `</div>`;
        return outputHTML;
    }

    thumbnailItemHtml() {
        var _self = this,
            item = _self.singleItem,
            outputHTML = `
                <div class="voyager-lightbox__thumbnail-item splide__slide">`;
        if (item.type === 'image') {
            outputHTML += `<img src="${item.link}" alt="" class="voyager-lightbox__thumbnail-image" />`
        }

        if (item.type === 'video') {
            outputHTML += `<img src="${item.poster}" alt="" class="voyager-lightbox__thumbnail-image" />`
        }

        outputHTML += `</div>`;

        return outputHTML;
    }

    addMedia() {
        var _self = this,
            item = _self.singleItem;
        if (item) {
            var mediaHTML = '';
            if (item.type === 'image') {
                mediaHTML = '<img src="' + item.link + '" alt="Lightbox Image" class="voyager-lightbox__slide-image">';
            }

            if (item.type === 'video') {
                mediaHTML = `
                    <video class="voyager-lightbox__video voyager-lightbox__slide-video video-js" controls muted preload="auto">
                        <source src="${item.link}">
                    </video>`
            }

            if(item.type === 'story') {
                const popup_content = item.popup_content;
                const content = JSON.parse(popup_content);
                mediaHTML = _self.story.outputHTML(content);
            }

            return {
                'mediaHTML': mediaHTML,
                'caption': item.caption
            };
        }
    }

    closeHtml() {
        var _self = this,
            outputHTML = '';
        const { icons } = _self.options;
        var close = icons.close;
        outputHTML += `
            <div class="voyager-lightbox__controls">
                <button class="voyager-lightbox__button-close voyager-lightbox__button js-lightbox-close" tabindex="2" aria-label="Close">${close}</button>
            </div>`;

        return outputHTML;
    }

    arrowsHtml() {
        var _self = this,
            outputHTML = `
            <div class="voyager-lightbox__control-bar splide__control-bar voyager-control-bar">
                <div class="splide__arrows splide__arrows-wrapper voyager-lightbox__arrows-wrapper">
                    <button class="splide__arrow splide__arrow--prev splide__arrows-button voyager-lightbox__arrows-button splide__arrows-button--prev voyager-lightbox__arrows-button--prev">
                        <i class="splide__arrows-icon voyager-lightbox__arrows-icon splide__arrows-icon--prev voyager-lightbox__arrows-icon--prev voyager-icon-arrow-pointing-left-big voyager-icon"></i>
                    </button>
                    <button class="splide__arrow splide__arrow--next splide__arrows-button voyager-lightbox__arrows-button splide__arrows-button--next voyager-lightbox__arrows-button--next">
                        <i class="splide__arrows-icon voyager-lightbox__arrows-icon splide__arrows-icon--next voyager-lightbox__arrows-icon--next voyager-icon-arrow-pointing-right-big voyager-icon"></i>
                    </button>
                </div>
            </div>
        `;

        return outputHTML;
    }

    thumbnailHtml() {
        var _self = this,
            outputHTML = '';

        if (_self.selectorDataset.lightboxVariation !== undefined) {
            _self.popupMain.classList.add('voyager-lightbox--thumbnail');
            outputHTML = `
                <div class="voyager-lightbox__thumbnail-slider splide js-lightbox-thumbnail">
                    <div class="voyager-lightbox__thumbnail-track splide__track">
                        <div class="voyager-lightbox__thumbnail-items splide__list">
                            ${_self.getItemsHtml().thumbnailItemHtml}
                        </div>
                    </div>
                </div>`;
        }

        return outputHTML;
    }

    splideInit() {
        var _self = this;

        _self.mainSplide = new Splide('.js-lightbox-items', {
            rewind: true,
            pagination: false,
            arrows: true,
            classes: {
                arrows: 'splide__arrows voyager-lightbox__arrows',
                prev: 'splide__arrow--prev voyager-lightbox__splide-arrow--prev',
                next: 'splide__arrow--next voyager-lightbox__splide-arrow--next',
            },
        });

        if (_self.popupMain.querySelector('.js-lightbox-thumbnail') !== null) {
            var thumbnails = new Splide('.js-lightbox-thumbnail', {
                fixedWidth: 200,
                fixedHeight: 120,
                gap: 10,
                rewind: true,
                pagination: false,
                isNavigation: true,
                arrows: false,
                breakpoints: {
                    600: {
                        fixedWidth: 120,
                        fixedHeight: 100,
                    },
                },
            });

            _self.mainSplide.sync(thumbnails);
            thumbnails.mount();
        }

        _self.mainSplide.mount();

        _self.mainSplide.go(_self.currentIndex);
        if(_self.story) {
            _self.story.splideInit(_self.currentIndex, _self.mainSplide);
        }


        const videos = _self.popupMain.querySelectorAll('video');
        videos.forEach((item) => {
            videojs(item);
        });

        _self.mainSplide.on('moved', function (newIndex, oldIndex) {
            _self.currentIndex = newIndex;
            var prevSlideVideo = _self.mainSplide.Components.Elements.slides[oldIndex].querySelector('video');
            if (prevSlideVideo) {
                prevSlideVideo.pause();
            }

            _self.videoInit(newIndex);
            if(_self.story) {
                _self.story.splideInit(newIndex, _self.mainSplide);
            }
            
        });

        _self.videoInit(_self.currentIndex);
    }

    handlePopupClose() {
        var _self = this;

        _self.popupMain.querySelector('.js-lightbox-close').addEventListener('click', function () {
            _self.popupMain.remove();
            _self.isOpen = false;

            document.body.classList.remove('js-lightbox-opened');
        })
    }

    videoInit(currentIndex) {
        var _self = this,
            item = _self.mainSplide.Components.Elements.slides[currentIndex].querySelector('video');

        if (item !== null) {
            var video = videojs(item);
            video.play();
        }
    }

    init() {
        this.groupElement();
    }
}

const voyagerLightbox = new VoyagerLightbox();
voyagerLightbox.init()

